import React from 'react';
import './styles/App.css';
import { PageLayout } from './components/Layout/PageLayout';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { TAPForm } from './components/Forms/TAPForm';
import { MFADetailForm } from './components/Forms/MFADetailForm';
import { MFABulkForm } from './components/Forms/MFABulkForm';
import { B2CUserTOUForm } from './components/Forms/B2CUserTOUForm'; 
import { SignInActivityForm } from './components/Forms/SignInActivityForm';
import { SummerrainUsersForm } from './components/Forms/SummerrainUsersForm';
import { B2CSignInEventsForm } from './components/Forms/B2CSignInEventsForm';
import { Route, Routes, Navigate } from 'react-router';
import env from 'react-dotenv';
import { ADLockoutForm } from './components/Forms/ADLockoutForm';
import { Home } from './components/Home/Home';
import { SharePointPermissionsForm } from './components/Forms/SharePointPermissionsForm';
import { ActivityLogForm } from './components/Forms/ActivityLogForm';
import { AppRegistrationForm } from './components/Forms/AppRegistrationForm';



const MainContent = () => {
    return (
        <div className="App">
            <AuthenticatedTemplate>
                <Routes>
                    <Route path="/tap" element={<TAPForm />}/>
                    <Route path="/mfa" element={<MFADetailForm />} />
                    <Route path="/mfaBulk" element={<MFABulkForm />} />
                    <Route path="/tou" element={<B2CUserTOUForm />}/>
                    {/* <Route index element={ <Navigate to="/tap" /> } /> */}
                    <Route path="/signInActivity" element={<SignInActivityForm />}/>
                    <Route path="/summerrainUsers" element={<SummerrainUsersForm />}/>
                    <Route path="/sharePointPermissions" element={<SharePointPermissionsForm />}/>
                    <Route path="/b2cSignInEvents" element={<B2CSignInEventsForm />}/>
                    <Route path="/adLockout" element={<ADLockoutForm />}/>
                    <Route path="/activityLog" element={<ActivityLogForm />} />
                    <Route path="/appRegistration" element={<AppRegistrationForm />} />
                    <Route index element={<Home/> } />
                </Routes>
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <h5 className="card-title">Please sign-in.</h5>
            </UnauthenticatedTemplate>
        </div>
    );
};

export default function App() {
    return (
        <PageLayout>
            <MainContent />
        </PageLayout>
    );
}
